"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.67 0c5.5.47 9.84 4.8 10.3 10.3l.02.01c.03.45-.13.88-.45 1.2l-.77.77c-.58.58-1.59.58-2.17 0l-1.49-1.49c-.48-.48-.59-1.21-.27-1.81l.83-1.55c-.45-1.6-1.7-2.86-3.3-3.31l-1.55.83c-.59.31-1.33.21-1.81-.27l-1.3-1.3a1.53 1.53 0 0 1-.45-1.08c0-.4.16-.79.45-1.08l.77-.77c.28-.29.68-.45 1.08-.45h.11Zm8.39 11.58.78-.78h.01c.11-.12.17-.28.16-.43-.42-5.03-4.38-8.98-9.41-9.41a.564.564 0 0 0-.43.16l-.78.78c-.1.11-.16.25-.16.4 0 .15.05.29.16.4l1.3 1.3c.17.18.44.22.66.1l1.72-.93c.1-.06.23-.08.36-.04 2.1.52 3.72 2.14 4.23 4.24.03.12.01.24-.05.35l-.93 1.72c-.12.22-.08.48.1.66l1.48 1.48c.11.1.24.16.4.16.16 0 .3-.06.4-.16Zm.35 2.43a.499.499 0 0 0-.58.4C20.93 19.3 16.65 23 11.5 23 5.7 23 1 18.3 1 12.5 1 7.35 4.7 3.07 9.59 2.17a.499.499 0 0 0-.18-.98C4.06 2.17 0 6.86 0 12.5 0 18.85 5.15 24 11.5 24c5.64 0 10.32-4.05 11.31-9.41a.499.499 0 0 0-.4-.58Zm-15.96.39c.09.489.488.798 1.025.8.827-.003 1.305-.643 1.345-2.08-.34.49-.88.76-1.54.76-1.21 0-2.01-.78-2.01-2.04s.88-2.12 2.19-2.12c.72 0 1.31.26 1.71.74.43.52.65 1.3.65 2.3 0 2.09-.83 3.27-2.35 3.27-1.13 0-1.91-.64-2-1.63h.98Zm1.03-1.34c-.7 0-1.17-.48-1.17-1.23s.43-1.25 1.16-1.25c.36 0 .65.13.87.35.21.22.33.54.33.92 0 .73-.49 1.22-1.19 1.22v-.01Zm5.73 2.81h-1.02v-4.25h-1.55v-.72h.34c.41 0 .73-.08.95-.27.19-.17.32-.41.38-.72l.02-.09h.88v6.05Zm3.86 0V9.82h-.88l-.02.09c-.06.31-.19.55-.38.72-.22.19-.54.27-.95.27h-.34v.72h1.55v4.25h1.02Z",
    clipRule: "evenodd"
  })]
});